import { render, staticRenderFns } from "./CartReview.vue?vue&type=template&id=4c70cfff&scoped=true&"
import script from "./CartReview.vue?vue&type=script&lang=ts&"
export * from "./CartReview.vue?vue&type=script&lang=ts&"
import style0 from "./CartReview.vue?vue&type=style&index=0&id=4c70cfff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c70cfff",
  null
  
)

export default component.exports